import axios from "axios";
import NProgress from "nprogress";

const apiOrder = axios.create({
  baseURL: "https://api.icap-maker.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});

apiOrder.interceptors.request.use(config => {
  NProgress.start();
  return config;
});

apiOrder.interceptors.response.use(response => {
  NProgress.done();
  return response;
});

export default {
  get_OTOrders() {
    return apiOrder.get("/Order/OneTimeOrders/");
  },
  LLCloseOTOrder(op) {
    return apiOrder({
      method: "post",
      url: "/Shipping/CloseOTOrderLL/",
      data: {
        _orderID: op.OrderID,
        _tracking: op.Tracking
      }
    });
  },
  Load_OTOrder(value) {
    return apiOrder({
      method: "post",
      url: "/Order/OneTimeOrder/",
      data: {
        _orderID: value
      }
    }); //.then(function(response) {
    //   user.UserProfileID = response.data["SaveUserResult"]
    // })
  }
};
